// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"033cb8b3","607":"11e9d0f9","626":"d1375285","645":"0b537ada","869":"cff5c70e"}[chunkId] + ".chunk.js";
};